import { render, staticRenderFns } from "./ListTemplate.vue?vue&type=template&id=de06e824&"
import script from "./ListTemplate.vue?vue&type=script&lang=js&"
export * from "./ListTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports